import cx from 'classnames';
import * as React from 'react';

import './AvatarWithTextItems.scss';

type Props = {
  children?: React.ReactNode;
  flush?: boolean;
};

export default function AvatarWithTextItems({ children, flush }: Props) {
  return (
    <div className={cx('AvatarWithTextItems', flush !== false && 'AvatarWithTextItems--flush')}>
      {children}
    </div>
  );
}
